import { render, staticRenderFns } from "./VideoInput.vue?vue&type=template&id=d50b60d8&"
import script from "./VideoInput.vue?vue&type=script&lang=ts&"
export * from "./VideoInput.vue?vue&type=script&lang=ts&"
import style0 from "./VideoInput.vue?vue&type=style&index=0&id=d50b60d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports